module.exports = __webpack_public_path__ + "img/super-hero-3.75600f5c.png";